import {
  Button,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react"
import React from "react"

export default function ResponsiveStyles() {
  return (
    <Flex direction="column" flexGrow={1} minHeight={0}>
      <Tabs>
        <TabList>
          <Tab>Buttons</Tab>
          <Tab>Texts</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Flex
              flexWrap="wrap"
              gap="1rem"
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              <Button variant="primaryResponsive">Primary</Button>
              <Button variant="MicroPrimaryResponsive">Micro Primary</Button>
            </Flex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  )
}
